"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultHash = {},
    currentLangHash = {};
/**
 * Получим тип формы слова для количественного определения. Например, 6 карт, 1 карта, 2 карты...
 * Соответственно, firstForm -> 'карта', secondForm -> 'карты', thirdForm -> 'карт'
 * @param {number} number
 * @param {object} options
 * @return {string}
 */

var _getWordFormByNumber = function _getWordFormByNumber() {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = 'firstForm',
      mod = number % 10;

  if (mod >= 2 && mod <= 4) {
    if (number % 100 < 10 || number % 100 > 20) {
      key = 'secondForm';
    } else {
      key = 'thirdForm';
    } // ищем 11 и другие числа,попадающие по третью форму

  } else if (number === 0 || mod !== 1 || mod === 1 && (number - 11) % 100 === 0) {
    key = 'thirdForm';
  }

  if (options.isSecond) {
    if (key === 'firstForm') {
      key = 'secondForm';
    } else if (key === 'secondForm') {
      key = 'thirdForm';
    }
  }

  return key;
};

var _helpers = [
/**
 * Заменяет {attributeName} на значение из options
 * @param {String} str
 * @param {Object} options
 * @return {String}
 */
function (str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return str.replace(/{([a-z][a-z0-9]*)}/gi, function (pattern, variableName) {
    if (options[variableName] === null || options[variableName] === undefined) {
      return '';
    }

    return options[variableName].toString();
  });
},
/**
 * Заменяет {attributeName:first word form|second form|third form}
 * на одну из указанных форм слова, в зависимости от значения из options
 * @param {String} str
 * @param {Object} options
 * @return {String}
 */
function (str, options) {
  if ((0, _typeof2["default"])(options) !== 'object') {
    return str;
  }

  return str.replace(/{([a-z][a-z0-9]*):([^|]+)\|([^|]+)\|([^|]+)}/gi, function (pattern, variableName, firstForm, secondForm, thirdForm) {
    if (options[variableName] === null) {
      return '';
    }

    if (isNaN(+options[variableName])) {
      return firstForm;
    }

    switch (_getWordFormByNumber(+options[variableName])) {
      case 'secondForm':
        return secondForm;

      case 'thirdForm':
        return thirdForm;

      default:
        return firstForm;
    }
  });
},
/**
 * Заменяет {first word form|second form|third form}
 * на одну из указанных форм слова, в зависимости от значения из options
 * @param {String} str
 * @param {number|string} firstParam
 * @return {String}
 */
function (str, firstParam) {
  if ((0, _typeof2["default"])(firstParam) === 'object') {
    return str;
  }

  return str.replace(/{([^|]+)\|([^|]+)\|([^|]+)}/gi, function (pattern, firstForm, secondForm, thirdForm) {
    if (!firstParam) {
      return '';
    }

    if (isNaN(+firstParam)) {
      return firstForm;
    }

    switch (_getWordFormByNumber(+firstParam)) {
      case 'secondForm':
        return secondForm;

      case 'thirdForm':
        return thirdForm;

      default:
        return firstForm;
    }
  });
}];
/**
 * Заменяет значения, обрабатываемые l10nHelpers
 * @param {String} str
 * @param {Object} options
 * @return {string}
 * @private
 */

var _processL10nHelpers = function _processL10nHelpers() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // ускорялка
  if (str.indexOf('{') > -1 && _helpers && _helpers.length) {
    _helpers.forEach(function (helper) {
      str = helper(str, options);
    });
  }

  return str;
};

var setDefaultLocale = function setDefaultLocale() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$merge = options.merge,
      merge = _options$merge === void 0 ? false : _options$merge;
  defaultHash = merge ? _objectSpread({}, defaultHash, {}, data) : data;
};

var setLocale = function setLocale() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$merge2 = options.merge,
      merge = _options$merge2 === void 0 ? false : _options$merge2;
  currentLangHash = merge ? _objectSpread({}, currentLangHash, {}, data) : data;
};

var getLocale = function getLocale() {
  return currentLangHash;
};

var getDefaultLocale = function getDefaultLocale() {
  return defaultHash;
};
/**
 * Выдает переведенную строку непосредственно для вставки в шаблон
 * @param {String} key
 * @param {Object} [options]
 * @return {String}
 */


var translate = function translate(key, options) {
  var translated = '';

  if (key) {
    key = String(key);
    translated = currentLangHash && currentLangHash[key] || defaultHash && defaultHash[key] || key;
    return _processL10nHelpers(translated, options);
  }

  return translated;
};

var _default = {
  t: translate,
  translate: translate,
  getDefaultLocale: getDefaultLocale,
  setDefaultLocale: setDefaultLocale,
  setLocale: setLocale,
  getLocale: getLocale
};
exports["default"] = _default;